import { useNavigate } from 'react-router-dom'
import { useAlertService } from '@/shared/lib/useAlertService'
import { useAuth } from '@/shared/context/AuthContext'
import { AuthService } from '@/shared/api/rest/services/auth.service'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { useState } from 'react'
import { UpdateProfileSchema } from '../profileSchema'

export default function useProfileUpdate({ initialData }: { initialData: any }) {
    const navigate = useNavigate()
    const alertService = useAlertService()
    const { refreshProfile } = useAuth()
    const [isUpdating, setIsUpdating] = useState(false)

    const {
        register,
        handleSubmit,
        control,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(UpdateProfileSchema),
        defaultValues: {
            firstName: initialData?.firstName || '',
            lastName: initialData?.lastName || '',
            phoneNumber: initialData?.phoneNumber || '',
            relationship: initialData?.relationship || '',
            branch: {
                label: initialData?.branch?.name || '',
                value: initialData?.branch?._id || ''
            },
            address: initialData?.address || '',
            city: initialData?.city || '',
            state: initialData?.state || '',
            country: {
                label: initialData?.country || 'Nigeria',
                value: initialData?.country || 'Nigeria'
            }
        }
    })

    async function updateProfile(formData: any) {
        setIsUpdating(true)
        try {
            // PATCH /auth/me routes user fields (name, phone) to the central
            // system and domain fields (relationship, address, branch) locally.
            await AuthService.updateProfile({
                firstName: formData.firstName,
                lastName: formData.lastName,
                phoneNumber: formData.phoneNumber,
                relationship: formData.relationship,
                address: formData.address,
                city: formData.city,
                state: formData.state,
                country: formData.country?.value ?? formData.country,
                branchId: formData.branch?.value
            })
            await refreshProfile()
            navigate('/user/dashboard')
            alertService.success('Profile information successfully updated')
        } catch (error) {
            alertService.error(
                error instanceof Error ? error.message : 'Unable to update profile'
            )
        } finally {
            setIsUpdating(false)
        }
    }

    return {
        isUpdating,
        errors,
        register,
        control,
        handleSubmit: handleSubmit(updateProfile)
    }
}
